"use strict";
/*
 * Created on 01 25 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Jaroslav Sevcik
 */


var SelloutCategoryDiscount =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutCategoryDiscount, _DomainObject_1$Domai);

  function SelloutCategoryDiscount(cmCategoryId, discount1, discount2) {
    var _this;

    _classCallCheck(this, SelloutCategoryDiscount);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutCategoryDiscount).call(this));
    _this.cmCategoryId = cmCategoryId;
    _this.discount1 = discount1;
    _this.discount2 = discount2;
    return _this;
  }

  return SelloutCategoryDiscount;
}(DomainObject_1.DomainObject);

exports.SelloutCategoryDiscount = SelloutCategoryDiscount;

SelloutCategoryDiscount.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutCategoryDiscount.name);
  return {
    cmCategoryId: builder.id('cmCategoryId'),
    discount1: builder.num('discount1'),
    discount2: builder.num('discount2')
  };
}();